import React, { useState } from 'react';
import { Nav, Image } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import {
  FaHome, FaUser, FaUserLock, FaClipboardCheck, FaCalendarCheck, FaUmbrellaBeach, FaMoneyCheckAlt, FaRegCalendar, FaCog, FaSignOutAlt, FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import { baseURL,imageUrl } from '../services/api';
import { AuthContext } from '../context/AuthContext';
import logoImg from '../assets/logo.jpg';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const toggleSidebar = () => setCollapsed(!collapsed);
const { user } = useContext(AuthContext);
console.log(user);
  return (
    <div className="layout">
      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="logo-container">
          
                <Image src={logoImg} alt="App Logo" style={{ height: '30px' }} />
              
          </div>
          <button onClick={toggleSidebar} className="toggle-btn">
            {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </button>
        </div>

        <Nav className="sidebar-nav">

          
{user.role !== 'employee' &&(
          <Link to="/" className={`nav-item ${isActive('/')}`}>
            <FaHome className="icon" />
            {!collapsed && <span>Dashboard</span>}
          </Link>
)}

                 
{user.role === 'employee' && (
  <>
    <Link to="/" className={`nav-item ${isActive('/')}`}>
      <FaHome className="icon" />
      {!collapsed && <span>Dashboard</span>}
    </Link>
    <Link to="/leaves" className={`nav-item ${isActive('/leaves')}`}>
      <FaUmbrellaBeach className="icon" />
      {!collapsed && <span>Apply Leaves</span>}
    </Link>
  </>
)}



          {user.role !== 'employee' &&(
            <div className="nav-section has-submenu">
            <div className="nav-item">
              <FaCalendarCheck className="icon" />
              {!collapsed && <span>Employees</span>}
            </div>
            <div className="submenu">
              <Link to="/employees" className={isActive('/employees')}>Employees</Link>
            </div>
          </div>
        )   } 


          

{user.role !== 'employee' && (
          <div className="nav-section has-submenu">
            <div className="nav-item">
              <FaCalendarCheck className="icon" />
              {!collapsed && <span>Attendance</span>}
            </div>
            <div className="submenu">
              <Link to="/attendance" className={isActive('/attendance')}>Daily Logs</Link>
              <Link to="/monthly-summary" className={isActive('/monthly-summary')}>Monthly Summary</Link>
              <Link to="/yearly-attendance" className={isActive('/yearly-attendance')}>Yearly Calendar</Link>
            </div>
          </div>
        )}

   


{(user.role === 'admin' || user.role === 'superadmin') && (
  <div className="nav-section has-submenu">
    <div className="nav-item">
      <FaUmbrellaBeach className="icon" />
      {!collapsed && <span>Leaves</span>}
    </div>
    <div className="submenu">
      <Link to="/leaves/all" className={isActive('/leaves/all')}>Manage Leaves</Link>
      <Link to="/leaves/setup" className={isActive('/leaves/setup')}>Leaves Setup</Link>
      <Link to="/leaves/usage" className={isActive('/leaves/usage')}>Leaves Usage</Link>
      <Link to="/holidays" className={isActive('/holidays')}>Holidays</Link>
    </div>
  </div>
)}


{/* {user.role !== 'employee' &&(
          <div className="nav-section has-submenu">
            <div className="nav-item">
              <FaMoneyCheckAlt className="icon" />
              {!collapsed && <span>Payroll</span>}
            </div>
            <div className="submenu">
              <Link to="/payroll-summary" className={isActive('/payroll-summary')}>Payroll Summary</Link>
              {/* <Link to="/payroll" className={isActive('/payroll')}>Payroll</Link> *\/}
            </div>
          </div>
)} */}

{user.role !== 'employee' && (
          <div className="nav-section has-submenu">
            <div className="nav-item">
              <FaClipboardCheck className="icon" />
              {!collapsed && <span>Appraisals</span>}
            </div>
            <div className="submenu">
              <Link to="/app/employee-appraisals" className={isActive('/app/employee-appraisals')}>All Appraisals</Link>
            </div>
          </div>
)}

  


        </Nav>



















        

        <div className="bottom-section">
          {user.role !== 'superadmin' && (
            <Link to="/my-profile" className={`nav-item ${isActive('/my-profile')}`}>
              <FaUser className="icon" />
              {!collapsed && <span>My Profile</span>}
            </Link>
          )}
               {/* Settings Section */}
        {(user.role === 'admin' || user.role === 'superadmin') && (
          <div className="nav-section has-submenu">
            <div className="nav-item">
              <FaCog className="icon" />
              {!collapsed && <span>Settings</span>}
            </div>
            <div className="submenu">
              <Link to="/settings" className={isActive('/settings')}>General Settings</Link>
              <Link to="/departments" className={isActive('/departments')}>Departments</Link>
              <Link to="/designations" className={isActive('/designations')}>Designations</Link>
            </div>
          </div>
        )}
          <Link to="/change-password" className={`nav-item ${isActive('/change-password')}`}>
            <FaUserLock className="icon" />
            {!collapsed && <span>Change Password</span>}
          </Link>
          
          <button className="nav-item logout" onClick={handleLogout}>
            <FaSignOutAlt className="icon" />
            {!collapsed && <span>Logout</span>}
          </button>
        </div>
      </div>

      <div className="content">{children}</div>

      <style>{`
        .layout { 
          display: flex; 
          height: 100vh; 
          background: #f5f7fa;
        }

        .sidebar {
          width: 260px;
          background: linear-gradient(180deg, #2c3e50 0%, #1a2533 100%);
          color: #e4e6eb;
          display: flex;
          flex-direction: column;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
          border-right: 1px solid rgba(255, 255, 255, 0.05);
        }
        
        /* Hide sidebar on mobile devices */
        @media (max-width: 767px) {
          .sidebar {
            display: none;
          }
          
          .content {
            width: 100%;
          }
        }

        .sidebar.collapsed { 
          width: 70px; 
          overflow: hidden;
        }

        .sidebar-header { 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          padding: 20px 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          position: relative;
        }

        .logo-container {
          display: flex;
          align-items: center;
          height: 40px;
        }

        .logo {
          height: 40px;
          width: auto;
          transition: opacity 0.3s;
        }

        .sidebar.collapsed .logo {
          opacity: 0;
        }

        .sidebar.collapsed .logo-container {
          display: none;
        }

        .toggle-btn {
          background: rgba(242, 235, 235, 0.2);
          border: none;
          border-radius: 6px;
          color: white;
          padding: 6px;
          cursor: pointer;
        }

        .sidebar-nav { flex-grow: 1; display: flex; flex-direction: column; }

        .nav-item {
          display: flex;
          align-items: center;
          padding: 12px 20px;
          color: #e4e6eb;
          text-decoration: none;
          border: none;
          background: transparent;
          width: 100%;
          cursor: pointer;
          position: relative;
          transition: all 0.2s ease;
          font-size: 0.9rem;
          border-left: 3px solid transparent;
        }

        .nav-item .icon { font-size: 20px; }

        .nav-item span { margin-left: 12px; font-size: 16px; }

        .nav-item:hover {
  background: #fff;
  color: #222;
  font-weight: bold;
  border-left: 4px solid #fff;
  box-shadow: 0 2px 8px rgba(246, 251, 246, 0.52);
  transition: background 0.2s, color 0.2s, border-left 0.2s;
}

.nav-item.active {
  background: rgba(74, 144, 226, 0.15);
  color: #4a90e2;
  font-weight: 500;
  border-left: 3px solid #4a90e2;
}

        .nav-item.active {
          background: rgba(255,255,255,0.2);
          font-weight: bold;
          // border-left: 3px solid white;
          color:#fff
        }

        .nav-section { position: relative; }

        .submenu {
          display: none;
          flex-direction: column;
          position: absolute;
          top: 0;
          left: 100%;
          background: #2c3e50;
          border-radius: 0 8px 8px 0;
          box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.2);
          padding: 8px 0;
          min-width: 200px;
          z-index: 1000;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .has-submenu:hover .submenu {
          display: flex;
        }

        .submenu a {
          padding: 10px 20px;
          color: #e4e6eb;
          text-decoration: none;
          font-size: 0.85rem;
          transition: all 0.2s ease;
          display: block;
        }

        .submenu a:hover {
          background: rgba(255, 255, 255, 0.05);
          color: #4a90e2;
          padding-left: 25px;
        }

        .submenu a.active {
          background: rgba(255,255,255,0.2);
          color: #fff;
          font-weight: bold;
          // border-left: 4px solid #fff;
        }


        .bottom-section { 
          margin-top: auto; 
          display: flex; 
          flex-direction: column;
          padding: 0;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .nav-item {
          display: flex;
          align-items: center;
          padding: 12px 20px;
          color: #e4e6eb;
          text-decoration: none;
          border: none;
          background: transparent;
          width: 100%;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 0.9rem;
          border-left: 3px solid transparent;
        }
        
        .nav-item:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
        
        .nav-item .icon {
          margin-right: 12px;
          font-size: 1.1rem;
          width: 20px;
          text-align: center;
        }

        .content { 
          flex: 1; 
          background: #f5f7fa; 
          overflow-y: auto;
        }
      `}</style>
    </div>
  );
};

export default Layout;